<template>
    <div id="app">
        <div class="app_main">
            <Top v-if="isRouterAlive"/>
            <div style="height:90px;"></div>
            <router-view />
            <Bottom />
        </div>
    </div>
</template>
<script>
import Top from "@/components/Top.vue";
import Bottom from "@/components/Bottom.vue";
import { getAction } from "@/api/services";
export default {
    name: "App",
    components: {
        Top,
        Bottom,
    },
    provide() {
        //父组件中通过provide来提供变量，在子组件中通过inject来注入变量。
        return {
            reload: this.reload,
        };
    },
    data() {
        return {
            isRouterAlive: true, //控制视图是否显示的变量
        };
    },
    mounted() {
        // this.getMenuData();
    },
    methods: {
        reload() {
            this.isRouterAlive = false; //先关闭，
            this.$nextTick(function () {
                this.isRouterAlive = true; //再打开
            });
        },
        getMenuData(){
            let that = this;
            getAction("/jhwlweb/gwweb/cmsArticleCategory/queryAllCategory")
            .then((res) => {
                if (res.code == 200 && res.success) {
                    sessionStorage.removeItem('menuInfo');
                    sessionStorage.setItem("menuInfo",JSON.stringify(res.result)); 
                }
            });
        },
    },
};
</script>
<style lang="less">
ol,
ul,
dl {
    list-style: none;
}
#app {
    display: block;
    width: 100%;
    position: relative;
    overflow-x: hidden;
    font-family: "微软雅黑";
}
// .app_main{
//     width: 1250px;
//     margin: 0 auto;
// }
.main_center_img{
    width: 1920px;
    margin: 0 auto;
    display: block;
    margin-left:-310px;
}
.main_center_box{
    width: 1300px;
    margin: 0 auto;
}
.main_bg_img{
    margin-left:-310px;
}
</style>
